import template from './acris-blog-author-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-blog-author-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            showDeleteModal: false,
            repository: null,
            total: 0
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        entityRepository() {
            return this.repositoryFactory.create('acris_blog_author');
        },

        columns() {
            return this.getColumns();
        }
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort('createdAt', 'DESC'));

            // criteria.addAssociation('blogs');

            this.entityRepository.search(criteria, Shopware.Context.api).then((items) => {
                this.total = items.total;
                this.items = items;
                this.isLoading = false;

                return items;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onDelete(id) {
            this.showDeleteModal = id;
            this.getList();
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
        },

        getColumns() {
            return [{
                property: 'firstName',
                inlineEdit: 'string',
                label: 'acris-blog-author.list.columnFirstName',
                routerLink: 'acris.blog.author.detail',
                allowResize: true,
                primary: true,
                width: '200px'
            }, {
                property: 'lastName',
                label: 'acris-blog-author.list.columnLastName',
                routerLink: 'acris.blog.author.detail',
                inlineEdit: 'string',
                allowResize: true,
                width: '200px'
            }];
        }
    }
});

